import type { DisplayError } from '../bridge/errors';
import { RetryButton, SidebarState } from './SidebarState';

interface RemoteListLike {
  items: unknown[];
  loading: boolean;
  error: DisplayError | null;
  reload: () => void;
}

/**
 * The loading / error / empty ladder every searchable remote list renders
 * before its rows. Renders nothing once items exist.
 */
export function RemoteListStates({
  list,
  searching,
  loading,
  errorTitle,
  empty
}: {
  list: RemoteListLike;
  searching: boolean;
  loading: { title: string; description: string };
  errorTitle: string;
  empty: {
    searchTitle: string;
    searchDescription: string;
    initialTitle: string;
    initialDescription: string;
  };
}) {
  if (list.items.length > 0) return null;
  if (list.loading) {
    return (
      <SidebarState
        compact
        kind="loading"
        title={loading.title}
        description={loading.description}
      />
    );
  }
  if (list.error) {
    return (
      <SidebarState
        compact
        kind="error"
        title={errorTitle}
        description={list.error.message}
        action={<RetryButton onClick={list.reload} />}
      />
    );
  }
  return (
    <SidebarState
      compact
      title={searching ? empty.searchTitle : empty.initialTitle}
      description={searching ? empty.searchDescription : empty.initialDescription}
    />
  );
}
